import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PropertiesIncludedInExport = ({
  onChange,
  value,
  selectedColumns
}) => {
  const includePropertiesInView = !!selectedColumns.length && !!value;
  const includePropertiesInViewDisabled = !selectedColumns.length;
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.exportSubmissions.includedInExport.header"
    }),
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "included-in-export",
      children: [/*#__PURE__*/_jsx(Tooltip, {
        disabled: !includePropertiesInViewDisabled,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.exportSubmissions.includedInExport.propertiesInViewDisabledTooltip"
        }),
        children: /*#__PURE__*/_jsx(UIRadioInput, {
          "data-test-id": "only-properties-in-the-view",
          checked: includePropertiesInView,
          disabled: includePropertiesInViewDisabled,
          onChange: () => onChange(selectedColumns),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "assetActionsLibForms.modals.exportSubmissions.includedInExport.onlyPropertiesInTheView"
          })
        })
      }), /*#__PURE__*/_jsx(UIRadioInput, {
        "data-test-id": "all-properties-on-records",
        checked: !includePropertiesInView,
        onChange: () => onChange(undefined),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.exportSubmissions.includedInExport.allPropertiesOnRecords"
        })
      })]
    })
  });
};
export default PropertiesIncludedInExport;